import { useState, useEffect, useRef } from 'react';
import DashboardSidebar from './DashboardSidebar';
import DashboardHeader from './DashboardHeader';

const DashboardLayout = ({
    children,
    tabs = [],
    activeTab = 'dashboard',
    onTabChange,
    headerTitle = 'Dashboard',
    headerSubtitle = '',
    headerIcon: HeaderIcon,
    headerIconBgColor = 'bg-blue-50',
    headerIconColor = 'text-blue-600',
    showSearch = false,
    searchValue = '',
    onSearchChange = () => {},
    badgeCounts = {}
}) => {
    // Initialize sidebar state based on screen size
    const [sidebarOpen, setSidebarOpen] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth >= 1024;
        }
        return false;
    });
    const sidebarRef = useRef(null);

    // Handle sidebar state on resize
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setSidebarOpen(true);
            }
        };

        const handleClickOutside = (event) => {
            if (sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                // Check if click is not on the menu toggle button
                const menuButton = event.target.closest('[data-menu-toggle]');
                if (!menuButton && window.innerWidth < 1024) {
                    setSidebarOpen(false);
                }
            }
        };

        window.addEventListener('resize', handleResize);
        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarOpen]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="min-h-screen bg-gray-50 flex">
            {/* Sidebar */}
            <div ref={sidebarRef}>
                <DashboardSidebar
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={onTabChange}
                    isOpen={sidebarOpen}
                    onToggle={toggleSidebar}
                    badgeCounts={badgeCounts}
                />
            </div>

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col lg:ml-64">
                {/* Header */}
                <DashboardHeader
                    icon={HeaderIcon}
                    title={headerTitle}
                    subtitle={headerSubtitle}
                    iconBgColor={headerIconBgColor}
                    iconColor={headerIconColor}
                    onMenuToggle={toggleSidebar}
                    showSearch={showSearch}
                    searchValue={searchValue}
                    onSearchChange={onSearchChange}
                />

                {/* Page Content */}
                <main className="flex-1 overflow-y-auto">
                    <div className="w-full h-full px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
